(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
/* Product-description Read more.
   Existing products keep the approved exact cut after:
   "Slow down. Stay with it. Let it be felt."

   Dulce Fama, Discovery Set I, Discovery Set II and The Collector's Edition
   also get a reliable fallback when their description is stored as one HTML block. */
if (!customElements.get('af-product-description')) {
  customElements.define('af-product-description', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-af-description-content]');
      this.button = this.querySelector('[data-af-description-toggle]');

      if (!this.content || !this.button || this.dataset.collapse === 'false') return;
      if (this.dataset.afPrepared === 'true') return;

      this.dataset.afPrepared = 'true';
      this.abort = new AbortController();

      this.button.addEventListener(
        'click',
        () => this.toggleDescription(),
        { signal: this.abort.signal }
      );

      this.prepareReadMore();
    }

    normalizeText(value) {
      return (value || '')
        .replace(/\u00a0/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }

    buildTextMap() {
      const walker = document.createTreeWalker(this.content, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      let node;

      while ((node = walker.nextNode())) {
        if (node.nodeValue) textNodes.push(node);
      }

      let normalized = '';
      const positionMap = [];

      textNodes.forEach((textNode) => {
        const value = textNode.nodeValue.replace(/\u00a0/g, ' ');

        for (let i = 0; i < value.length; i++) {
          const char = value[i];

          if (/\s/.test(char)) {
            if (normalized.length && normalized[normalized.length - 1] !== ' ') {
              normalized += ' ';
              positionMap.push({ node: textNode, offset: i + 1 });
            }
          } else {
            normalized += char;
            positionMap.push({ node: textNode, offset: i + 1 });
          }
        }
      });

      return { text: normalized, map: positionMap };
    }

    findMarkerEnd(markerText) {
      const result = this.buildTextMap();
      const text = result.text.toLowerCase();
      const marker = this.normalizeText(markerText);
      const markerStart = text.indexOf(marker);

      if (markerStart === -1) return null;

      const markerEndIndex = markerStart + marker.length - 1;
      return result.map[markerEndIndex] || null;
    }

    getTopLevelBlock(node) {
      let current = node.nodeType === Node.TEXT_NODE ? node.parentElement : node;

      while (current && current.parentElement !== this.content) {
        current = current.parentElement;
      }

      return current && current.parentElement === this.content ? current : null;
    }

    hideAfterApprovedMarker(markerEnd) {
      const markerBlock = this.getTopLevelBlock(markerEnd.node);
      if (!markerBlock) return false;

      let hasMore = false;
      const tailRange = document.createRange();
      tailRange.setStart(markerEnd.node, markerEnd.offset);
      tailRange.setEnd(markerBlock, markerBlock.childNodes.length);

      const tailFragment = tailRange.extractContents();

      if (tailFragment.textContent.trim() || tailFragment.querySelector?.('*')) {
        const tail = document.createElement('span');
        tail.className = 'af-pd-desc__after-read-more';
        tail.appendChild(tailFragment);
        markerBlock.appendChild(tail);
        hasMore = true;
      }

      let sibling = markerBlock.nextElementSibling;
      while (sibling) {
        if (sibling.textContent.trim().length > 0) {
          sibling.classList.add('af-pd-desc__after-read-more');
          hasMore = true;
        }
        sibling = sibling.nextElementSibling;
      }

      return hasMore;
    }

    hideAfterPreviewBlocks() {
      const blocks = Array.from(this.content.children).filter(
        (node) => node.textContent.trim().length > 0
      );

      const previewBlocks = Math.max(
        1,
        Math.min(4, parseInt(this.dataset.previewBlocks || '2', 10))
      );

      if (blocks.length <= previewBlocks) return false;

      let hasMore = false;

      blocks.forEach((block, index) => {
        if (index >= previewBlocks) {
          block.classList.add('af-pd-desc__after-read-more');
          hasMore = true;
        }
      });

      return hasMore;
    }

    splitSingleLongDescription() {
      const result = this.buildTextMap();
      const text = result.text;
      const map = result.map;

      /* Keep a useful preview while making Read more visible on the four
         products whose descriptions are stored as one long HTML block. */
      const target = 180;
      const minimumTail = 30;

      if (text.length <= target + minimumTail || map.length === 0) return false;

      let cutIndex = -1;
      const sentenceLimit = Math.min(text.length - minimumTail, target + 120);

      for (let i = target; i < sentenceLimit; i++) {
        if (text[i] === '.' || text[i] === '!' || text[i] === '?') {
          cutIndex = i + 1;
          break;
        }
      }

      if (cutIndex === -1) {
        const nextSpace = text.indexOf(' ', target);
        if (nextSpace !== -1 && nextSpace < text.length - minimumTail) {
          cutIndex = nextSpace;
        } else {
          cutIndex = target;
        }
      }

      const cutPosition = map[Math.max(0, cutIndex - 1)];
      if (!cutPosition) return false;

      const range = document.createRange();
      range.setStart(cutPosition.node, cutPosition.offset);
      range.setEnd(this.content, this.content.childNodes.length);

      const hiddenFragment = range.extractContents();

      if (!hiddenFragment.textContent.trim() && !hiddenFragment.querySelector?.('*')) {
        return false;
      }

      const hiddenContent = document.createElement('div');
      hiddenContent.className = 'af-pd-desc__after-read-more';
      hiddenContent.appendChild(hiddenFragment);
      this.content.appendChild(hiddenContent);

      return true;
    }

    prepareReadMore() {
      const markerText = this.dataset.readMoreAfter || '';
      const markerEnd = this.findMarkerEnd(markerText);
      const forceReadMore = this.dataset.forceReadMore === 'true';
      let hasMore = false;

      /* 1. Preserve the existing exact client-approved cut where available. */
      if (markerEnd) {
        hasMore = this.hideAfterApprovedMarker(markerEnd);
      }

      /* 2. Keep the existing block-based fallback for normal descriptions. */
      if (!markerEnd) {
        hasMore = this.hideAfterPreviewBlocks();
      }

      /* 3. Fix the four products that have a long description in one block. */
      if (!hasMore && forceReadMore) {
        hasMore = this.splitSingleLongDescription();
      }

      this.button.hidden = !hasMore;

      if (!hasMore) {
        this.dataset.collapsed = 'false';
        this.button.setAttribute('aria-expanded', 'true');
        return;
      }

      this.dataset.collapsed = 'true';
      this.button.setAttribute('aria-expanded', 'false');

      const label = this.button.querySelector('[data-af-description-label]');
      if (label) label.textContent = this.dataset.moreLabel;
    }

    toggleDescription() {
      const isCollapsed = this.dataset.collapsed === 'true';

      this.dataset.collapsed = isCollapsed ? 'false' : 'true';
      this.button.setAttribute('aria-expanded', String(isCollapsed));

      const label = this.button.querySelector('[data-af-description-label]');
      if (label) {
        label.textContent = isCollapsed
          ? this.dataset.lessLabel
          : this.dataset.moreLabel;
      }
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
